export const useGetShortCode = () => {
    const shortCode = localStorage.getItem('short_code');

    return shortCode;
};